module.exports = __webpack_public_path__ + "static/media/chefs-whites.b7bb092f.jpg";